import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  MessageContent,
  SendFromListContent,
  TagsContent,
  LinkContent,
  QRCodeContent,
} from 'widgets/DetailsContent'
import { useClickToTextDetailsModalContext } from 'pages/clickToText/pages/all/context'
import { downloadQRCodeAsPNG, downloadQRCodeAsSVG } from 'pages/clickToText/lib'
import styles from './styles.module.scss'

export const DetailsClickToTextBody = observer(() => {
  const clickToText = useClickToTextDetailsModalContext()
  const { message, attachments, textInNumberProps, tags, shortUrl, qrCode } = clickToText
  const entities = useEntitiesContext()
  const { eventLogStore, organizationStore } = entities

  const handleDownload = (format: 'SVG' | 'PNG') => {
    eventLogStore.logEvent(
      'Click to Text Used',
      {
        event_id: 'click_to_text_used',
        action: 'Download clicked',
        linkId: clickToText.id,
        agencyId: organizationStore.agency_id,
      },
      { groupId: organizationStore.id }
    )
    if (format === 'SVG') {
      downloadQRCodeAsSVG(qrCode)
    } else {
      downloadQRCodeAsPNG(qrCode)
    }
  }

  return (
    <div className={styles.bodyWrap}>
      <MessageContent message={message} attachments={attachments} type={'sms'} />
      <div className={styles.paramsWrap}>
        {!!textInNumberProps && (
          <SendFromListContent
            list={textInNumberProps}
            name={'ClickToText'}
            hideBorder
            label={'Text in number'}
          />
        )}
        <TagsContent tags={tags} />
        <QRCodeContent
          value={
            <div>
              <div className={styles.image}>
                <img src={qrCode} alt='QR Code' className={styles.qrImage} />
              </div>
              <div className={styles.actions}>
                <Button
                  fullWidth
                  text='PNG'
                  iconProps={{ icon: 'download' }}
                  size='small'
                  onClick={() => handleDownload('PNG')}
                />
                <Button
                  fullWidth
                  text='SVG'
                  iconProps={{ icon: 'download' }}
                  size='small'
                  onClick={() => handleDownload('SVG')}
                />
              </div>
            </div>
          }
        />
        <LinkContent link={shortUrl} />
      </div>
    </div>
  )
})
